'use strict';

/**
 * @ngdoc controller
 * @name observatoireApp.controller:TitresMinierDetailsCtrl
 * @description
 * Contrôleur pour la gestion des détails d'un titre minier
 */
angular
  .module('observatoireApp')
  .controller('TitresMinierDetailsCtrl', ['$http', '$scope', '$stateParams', 'MetaService', TitresMinierDetailsCtrl]);

function TitresMinierDetailsCtrl($http, $scope, $stateParams, MetaService) {
  var vm = this;
  
  // Initialisation des données
  $scope.titreMinier = null;
  $scope.loading = true;
  $scope.error = null;
  
  // Récupérer l'ID depuis l'URL
  var id = $stateParams.id;
  
  // Formatage de date
  $scope.formaterDate = function(dateStr) {
    if (!dateStr) return '';
    var date = new Date(dateStr);
    return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
  };
  
  // Méthode pour charger les détails d'un titre minier
  function chargerDetailsTitreMinier() {
    $scope.loading = true;
    $scope.error = null;
    
    $http.get('/api/titres-miniers/' + id)
      .then(function(response) {
        $scope.titreMinier = response.data;
        $scope.loading = false;
        
        // Mise à jour des métadonnées de la page
        if ($scope.titreMinier) {
          MetaService.setTitle('Titre minier - ' + ($scope.titreMinier.numeroTitre || 'Détails'));
          MetaService.setDescription('Détails du titre minier ' + $scope.titreMinier.numeroTitre + 
            ' attribué à ' + $scope.titreMinier.societe);
        }
        
        // Initialiser la carte
        setTimeout(function() {
          initMap();
        }, 100);
      })
      .catch(function(error) {
        $scope.error = 'Erreur lors du chargement des détails du titre minier: ' + 
          (error.data && error.data.message ? error.data.message : error.statusText);
        $scope.loading = false;
      });
  }
  
  // Initialiser la carte avec la position du titre minier
  function initMap() {
    if (!$scope.titreMinier || !$scope.titreMinier.latitude || !$scope.titreMinier.longitude) {
      return;
    }
    
    // Vérifier si l'élément DOM existe
    var mapElement = document.getElementById('titre-details-map');
    if (!mapElement) {
      return;
    }
    
    // Vérifier si la variable L (Leaflet) est définie
    if (typeof L !== 'undefined') {
      var lat = parseFloat($scope.titreMinier.latitude);
      var lng = parseFloat($scope.titreMinier.longitude);
      
      // Créer la carte centrée sur le titre minier
      var map = L.map('titre-details-map').setView([lat, lng], 10);
      
      // Ajouter la couche OpenStreetMap
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map);
      
      // Ajouter un marqueur pour le titre minier
      var marker = L.marker([lat, lng])
        .addTo(map)
        .bindPopup(
          '<strong>' + $scope.titreMinier.numeroTitre + '</strong><br>' +
          'Type: ' + $scope.titreMinier.typeTitre + '<br>' +
          'Société: ' + $scope.titreMinier.societe + '<br>' +
          'Substance: ' + $scope.titreMinier.substance + '<br>' +
          'Région: ' + $scope.titreMinier.region
        ).openPopup();
    }
  }
  
  // Initialisation
  chargerDetailsTitreMinier();
}
